import React from 'react';
import styled from 'styled-components';

import { toVw, toVwMobile } from '../utils/styles';
import mq from '@/utils/media-queries';

const Styled = styled.div`
  padding-left: ${toVw(180)};
  box-sizing: border-box;

  ${mq.mobile(css`
    padding-left: ${toVwMobile(30)};
  `)};
`;

const Indent = ({ children }) => <Styled>{children}</Styled>;

export default Indent;



// WEBPACK FOOTER //
// ./src/components/IndentSmall.js